<template>
  <nav class="d-flex flex-row">
    <section v-if="!toggleMenu" class="largeMenu">
      <ul class="">
        <li @click="toggleMenu = !toggleMenu">
          <span><font-awesome-icon :icon="['fas', 'chevron-circle-left']"></font-awesome-icon></span>
          <span>Réduire le menu</span>
        </li>
        <router-link tag="li" to="/">
          <span><font-awesome-icon :icon="['fas', 'tachometer-alt']"></font-awesome-icon></span>
          <span>Tableau de bord</span>
        </router-link>
        <router-link tag="li" to="acheteurs">
          <span><font-awesome-icon :icon="['fas', 'people-arrows']"></font-awesome-icon></span>
          <span>Acheteurs</span>
        </router-link>
        <router-link tag="li" to="actualites">
          <span><font-awesome-icon :icon="['fas', 'newspaper']"></font-awesome-icon></span>
          <span>Actualités</span>
        </router-link>
        <router-link tag="li" to="administrateurs">
          <span><font-awesome-icon :icon="['fas', 'user-cog']"></font-awesome-icon></span>
          <span>Administrateurs</span>
        </router-link>
        <li class="item-with-menu">
          <span><font-awesome-icon :icon="['fas', 'people-carry']"></font-awesome-icon></span>
          <span>Agents</span>
          <span><font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon></span>
          <ul>
            <router-link tag="li" to="livreurs">
              <span><font-awesome-icon :icon="['fas', 'truck-loading']"></font-awesome-icon></span>
              <span>Livreurs</span>
            </router-link>
            <router-link tag="li" to="receptionnistes">
              <span><font-awesome-icon :icon="['fas', 'person-booth']"></font-awesome-icon></span>
              <span>Réceptionnistes</span>
            </router-link>
          </ul>
        </li>
        <router-link tag="li" to="annonces">
          <span><font-awesome-icon :icon="['fas', 'bullhorn']"></font-awesome-icon></span>
          <span>Annonces</span>
        </router-link>
        <router-link tag="li" to="avis-clients">
          <span><font-awesome-icon :icon="['fas', 'gavel']"></font-awesome-icon></span>
          <span>Avis Clients</span>
        </router-link>
        <router-link tag="li" to="categories-produits">
          <span><font-awesome-icon :icon="['fas', 'clipboard-list']"></font-awesome-icon></span>
          <span>Catégories Produits</span>
        </router-link>
        <li class="item-with-menu">
          <span><font-awesome-icon :icon="['fas', 'truck']"></font-awesome-icon></span>
          <span>Commandes</span>
          <span><font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon></span>
          <ul>
            <router-link tag="li" to="commandes-annulees">
              <span><font-awesome-icon :icon="['fas', 'ban']"></font-awesome-icon></span>
              <span>Commandes annulées</span>
            </router-link>
            <router-link tag="li" to="commandes-encours">
              <span><font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon></span>
              <span>Commandes encours</span>
            </router-link>
            <router-link tag="li" to="commandes-livraison">
              <span><font-awesome-icon :icon="['fas', 'box-open']"></font-awesome-icon></span>
              <span>Commandes livrées</span>
            </router-link>
            <router-link tag="li" to="commandes-retournees">
              <span><font-awesome-icon :icon="['fas', 'undo']"></font-awesome-icon></span>
              <span>Commandes retournées</span>
            </router-link>
            <router-link tag="li" to="commandes-validees">
              <span><font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon></span>
              <span>Commandes validées</span>
            </router-link>
          </ul>
        </li>
        <router-link tag="li" to="faq">
          <span><font-awesome-icon :icon="['fas', 'question-circle']"></font-awesome-icon></span>
          <span>Faq</span>
        </router-link>
        <li class="item-with-menu">
          <span><font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon></span>
          <span>Messages</span>
          <span><font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon></span>
          <ul>
            <router-link tag="li" to="message-mail">
              <span><font-awesome-icon :icon="['fas', 'envelope-open-text']"></font-awesome-icon></span>
              <span>Mail</span>
            </router-link>
            <router-link tag="li" to="message-contact">
              <span><font-awesome-icon :icon="['fas', 'file-signature']"></font-awesome-icon></span>
              <span>Contact</span>
            </router-link>
          </ul>
        </li>
        <li class="item-with-menu">
          <span><font-awesome-icon :icon="['fas', 'shopping-cart']"></font-awesome-icon></span>
          <span>Produits</span>
          <span><font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon></span>
          <ul>
            <router-link tag="li" to="produits-encours">
              <span><font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon></span>
              <span>Produits disponible</span>
            </router-link>
            <router-link tag="li" to="produits-collectes">
              <span><font-awesome-icon :icon="['fas', 'undo']"></font-awesome-icon></span>
              <span>Produits retournés</span>
            </router-link>
            <router-link tag="li" to="produits-supprimes">
              <span><font-awesome-icon :icon="['fas', 'ban']"></font-awesome-icon></span>
              <span>Produits supprimés</span>
            </router-link>
            <router-link tag="li" to="produits-vendus">
              <span><font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon></span>
              <span>Produits vendus</span>
            </router-link>
          </ul>
        </li>
        <router-link tag="li" to="promotions">
          <span><font-awesome-icon :icon="['fas', 'percentage']"></font-awesome-icon></span>
          <span>Promotions</span>
        </router-link>
        <router-link tag="li" to="remboursements">
          <span><font-awesome-icon :icon="['fas', 'undo']"></font-awesome-icon></span>
          <span>Remboursements</span>
        </router-link>
        <router-link tag="li" to="suggestions-annonces">
          <span><font-awesome-icon :icon="['fas', 'volume-up']"></font-awesome-icon></span>
          <span>Suggestions Annonces</span>
        </router-link>
        <router-link tag="li" to="super-utilisateurs">
          <span><font-awesome-icon :icon="['fas', 'user-secret']"></font-awesome-icon></span>
          <span>Super Utilisateurs</span>
        </router-link>
        <router-link tag="li" to="transactions">
          <span><font-awesome-icon :icon="['fas', 'hand-holding-usd']"></font-awesome-icon></span>
          <span>Transactions</span>
        </router-link>
        <router-link tag="li" to="utilisateurs">
          <span><font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon></span>
          <span>Utilisateurs</span>
        </router-link>
        <router-link tag="li" to="vendeurs">
          <span><font-awesome-icon :icon="['fas', 'house-user']"></font-awesome-icon></span>
          <span>Vendeurs</span>
        </router-link>
      </ul>
      <div>&nbsp;</div>
    </section>
    <section v-if="toggleMenu" class="smallMenu">
      <ul class="">
        <li @click="toggleMenu = !toggleMenu">
          <span><font-awesome-icon :icon="['fas', 'chevron-circle-right']"></font-awesome-icon></span>
        </li>
        <router-link tag="li" to="/">
          <span><font-awesome-icon :icon="['fas', 'tachometer-alt']"></font-awesome-icon></span>
        </router-link>
        <router-link tag="li" to="acheteurs">
          <span><font-awesome-icon :icon="['fas', 'people-arrows']"></font-awesome-icon></span>
        </router-link>
        <router-link tag="li" to="actualites">
          <span><font-awesome-icon :icon="['fas', 'newspaper']"></font-awesome-icon></span>
        </router-link>
        <router-link tag="li" to="administrateurs">
          <span><font-awesome-icon :icon="['fas', 'user-cog']"></font-awesome-icon></span>
        </router-link>
        <li class="item-with-menu">
          <span><font-awesome-icon :icon="['fas', 'people-carry']"></font-awesome-icon></span>
          <span><font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon></span>
          <ul>
            <router-link tag="li" to="livreurs">
              <span><font-awesome-icon :icon="['fas', 'truck-loading']"></font-awesome-icon></span>
              <span>Livreurs</span>
            </router-link>
            <router-link tag="li" to="receptionnistes">
              <span><font-awesome-icon :icon="['fas', 'person-booth']"></font-awesome-icon></span>
              <span>Réceptionnistes</span>
            </router-link>
          </ul>
        </li>
        <router-link tag="li" to="annonces">
          <span><font-awesome-icon :icon="['fas', 'bullhorn']"></font-awesome-icon></span>
        </router-link>
        <router-link tag="li" to="avis-clients">
          <span><font-awesome-icon :icon="['fas', 'gavel']"></font-awesome-icon></span>
        </router-link>
        <router-link tag="li" to="categories-produits">
          <span><font-awesome-icon :icon="['fas', 'clipboard-list']"></font-awesome-icon></span>
        </router-link>
        <li class="item-with-menu">
          <span><font-awesome-icon :icon="['fas', 'truck']"></font-awesome-icon></span>
          <span><font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon></span>
          <ul>
            <router-link tag="li" to="commandes-annulees">
              <span><font-awesome-icon :icon="['fas', 'ban']"></font-awesome-icon></span>
              <span>Commandes annulées</span>
            </router-link>
            <router-link tag="li" to="commandes-encours">
              <span><font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon></span>
              <span>Commandes encours</span>
            </router-link>
            <router-link tag="li" to="commandes-livraison">
              <span><font-awesome-icon :icon="['fas', 'box-open']"></font-awesome-icon></span>
              <span>Commandes livrées</span>
            </router-link>
            <router-link tag="li" to="commandes-retournees">
              <span><font-awesome-icon :icon="['fas', 'undo']"></font-awesome-icon></span>
              <span>Commandes retournées</span>
            </router-link>
            <router-link tag="li" to="commandes-validees">
              <span><font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon></span>
              <span>Commandes validées</span>
            </router-link>
          </ul>
        </li>
        <router-link tag="li" to="faq">
          <span><font-awesome-icon :icon="['fas', 'question-circle']"></font-awesome-icon></span>
        </router-link>
        <li class="item-with-menu">
          <span><font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon></span>
          <span><font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon></span>
          <ul>
            <router-link tag="li" to="message-mail">
              <span><font-awesome-icon :icon="['fas', 'envelope-open-text']"></font-awesome-icon></span>
              <span>Mail</span>
            </router-link>
            <router-link tag="li" to="message-contact">
              <span><font-awesome-icon :icon="['fas', 'file-signature']"></font-awesome-icon></span>
              <span>Contact</span>
            </router-link>
          </ul>
        </li>
        <li class="item-with-menu">
          <span><font-awesome-icon :icon="['fas', 'shopping-cart']"></font-awesome-icon></span>
          <span><font-awesome-icon :icon="['fas', 'caret-left']"></font-awesome-icon></span>
          <ul>
            <router-link tag="li" to="produits-encours">
              <span><font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon></span>
              <span>Produits disponible</span>
            </router-link>
            <router-link tag="li" to="produits-collectes">
              <span><font-awesome-icon :icon="['fas', 'undo']"></font-awesome-icon></span>
              <span>Produits retournés</span>
            </router-link>
            <router-link tag="li" to="produits-supprimes">
              <span><font-awesome-icon :icon="['fas', 'ban']"></font-awesome-icon></span>
              <span>Produits supprimés</span>
            </router-link>
            <router-link tag="li" to="produits-vendus">
              <span><font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon></span>
              <span>Produits vendus</span>
            </router-link>
          </ul>
        </li>
        <router-link tag="li" to="promotions">
          <span><font-awesome-icon :icon="['fas', 'percentage']"></font-awesome-icon></span>
        </router-link>
        <router-link tag="li" to="remboursements">
          <span><font-awesome-icon :icon="['fas', 'undo']"></font-awesome-icon></span>
        </router-link>
        <router-link tag="li" to="suggestions-annonces">
          <span><font-awesome-icon :icon="['fas', 'volume-up']"></font-awesome-icon></span>
        </router-link>
        <router-link tag="li" to="super-utilisateurs">
          <span><font-awesome-icon :icon="['fas', 'user-secret']"></font-awesome-icon></span>
        </router-link>
        <router-link tag="li" to="transactions">
          <span><font-awesome-icon :icon="['fas', 'hand-holding-usd']"></font-awesome-icon></span>
        </router-link>
        <router-link tag="li" to="utilisateurs">
          <span><font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon></span>
        </router-link>
        <router-link tag="li" to="vendeurs">
          <span><font-awesome-icon :icon="['fas', 'house-user']"></font-awesome-icon></span>
        </router-link>
      </ul>
      <div>&nbsp;</div>
    </section>
  </nav>
</template>

<script>
export default {
  name: "Navigation",
  data () {
    return {
      toggleMenu: false
    }
  }
}
</script>

<style lang="scss" scoped>
nav {
  & > section.largeMenu{
    background-color: var(--color-maya-blue, rgba(100, 181, 246, 1));
    color: var(--color-white, rgba(255, 255, 255, 1));
    width: 220px;
    //
    & > ul{
      list-style: none;
      padding-left: 0;
      & > li:first-child{
        border-top: 1px solid var(--color-white, rgba(255, 255, 255, 1));
      }
      & > li{
        padding-top: .4rem;
        padding-bottom: .4rem;
        border-bottom: 1px solid var(--color-white, rgba(255, 255, 255, 1));
        display: flex;
        flex-direction: row;
        font-size: medium;
        & > span{
          display: block;
          text-align: center;
          align-self: center;
        }
        & > span:nth-child(1){
          width: 20%;
          font-size: large;
        }
        & > span:nth-child(2){
          width: 75%;
          text-align: left;
        }
        & > span:nth-child(3){
          display: none;
          color: var(--color-curious-blue, rgba(34, 134, 195, 1));
          margin-left: 20px;
        }
      }
      & > li:hover{
        background-color: var(--color-white, rgba(255, 255, 255, 1));
        color: var(--color-maya-blue, rgba(100, 181, 246, 1));
        cursor: pointer;
        & > span:nth-child(3){
          display: block;
        }
      }
      //
      & > li.item-with-menu{
        & > ul{
          display: none;
          background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
          color: var(--color-white, rgba(255, 255, 255, 1));
          list-style: none;
          position: absolute;
          padding-left: 0;
          width: 230px;
          left: 220px;
          margin-top: -6px;
          z-index: 3;
          & > li:first-child{
            border-top: 1px dashed var(--color-white, rgba(255, 255, 255, 1));
          }
          & > li{
            padding-top: .4rem;
            padding-bottom: .4rem;
            border-bottom: 1px dashed var(--color-white, rgba(255, 255, 255, 1));
            display: flex;
            flex-direction: row;
            font-size: medium;
            & > span{
              display: block;
              text-align: center;
              align-self: center;
            }
            & > span:nth-child(1){
              width: 20%;
              font-size: large;
            }
            & > span:nth-child(2){
              width: 75%;
              text-align: left;
            }
            & > span:nth-child(3){
              color: var(--color-maya-blue, rgba(100, 181, 246, 1));
              margin-left: 20px;
            }
          }
          & > li:first-child:hover{
            border-top: 1px dashed var(--color-curious-blue, rgba(34, 134, 195, 1));
          }
          & > li:hover{
            background-color: var(--color-white, rgba(255, 255, 255, 1));
            color: var(--color-curious-blue, rgba(34, 134, 195, 1));
            cursor: pointer;
            border-bottom: 1px dashed var(--color-curious-blue, rgba(34, 134, 195, 1));
          }
        }
      }
      & > li.item-with-menu:hover{
        & > ul{
          display: block;
        }
      }
    }
  }
  & > section.smallMenu{
    background-color: var(--color-maya-blue, rgba(100, 181, 246, 1));
    color: var(--color-white, rgba(255, 255, 255, 1));
    width: 50px;
    //
    & > ul{
      list-style: none;
      padding-left: 0;
      & > li:first-child{
        border-top: 1px solid var(--color-white, rgba(255, 255, 255, 1));
      }
      & > li{
        padding-top: .4rem;
        padding-bottom: .4rem;
        border-bottom: 1px solid var(--color-white, rgba(255, 255, 255, 1));
        display: flex;
        flex-direction: row;
        font-size: medium;
        & > span{
          display: block;
          text-align: center;
          align-self: center;
        }
        & > span:nth-child(1){
          padding-left: 1rem;
          font-size: large;
        }
        & > span:nth-child(2){
          text-align: left;
        }
        & > span:nth-child(3){
          display: none;
          color: var(--color-curious-blue, rgba(34, 134, 195, 1));
          margin-left: 20px;
        }
      }
      & > li:hover{
        background-color: var(--color-white, rgba(255, 255, 255, 1));
        color: var(--color-maya-blue, rgba(100, 181, 246, 1));
        cursor: pointer;
        & > span:nth-child(3){
          display: block;
        }
      }
      //
      & > li.item-with-menu{
        & > ul{
          display: none;
          background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
          color: var(--color-white, rgba(255, 255, 255, 1));
          list-style: none;
          position: absolute;
          padding-left: 0;
          width: 230px;
          left: 50px;
          margin-top: -6px;
          z-index: 3;
          & > li:first-child{
            border-top: 1px dashed var(--color-white, rgba(255, 255, 255, 1));
          }
          & > li{
            padding-top: .4rem;
            padding-bottom: .4rem;
            border-bottom: 1px dashed var(--color-white, rgba(255, 255, 255, 1));
            display: flex;
            flex-direction: row;
            font-size: medium;
            & > span{
              display: block;
              text-align: center;
              align-self: center;
            }
            & > span:nth-child(1){
              font-size: large;
            }
            & > span:nth-child(2){
              text-align: left;
            }
            & > span:nth-child(3){
              color: var(--color-maya-blue, rgba(100, 181, 246, 1));
              margin-left: -55px;
            }
          }
          & > li:first-child:hover{
            border-top: 1px dashed var(--color-curious-blue, rgba(34, 134, 195, 1));
          }
          & > li:hover{
            background-color: var(--color-white, rgba(255, 255, 255, 1));
            color: var(--color-curious-blue, rgba(34, 134, 195, 1));
            cursor: pointer;
            border-bottom: 1px dashed var(--color-curious-blue, rgba(34, 134, 195, 1));
          }
        }
      }
      & > li.item-with-menu:hover{
        & > ul{
          display: block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Navigation.vue